import React, { useEffect, useState, useContext } from 'react';
import styled from 'styled-components';
import DetectorController, {
  StoreStatusData,
  HotelListType,
  HotelStoreType,
  StoreStatusModalData,
} from '../../controller/DetectorController';
import Select from 'react-select';
import 'moment/locale/ko';
import moment from 'moment';
import StoreStatusModal from '../../components/modal/storeStatusModal';
import DateTab from '../../components/DateTab';
import { useNavigate } from 'react-router-dom';
import CustomTable from '../../components/Table';
import { AuthContext } from '../../navigation/TemporaryUserInfo';

const StoreStatus = () => {
  const navigate = useNavigate();
  const { logout } = useContext(AuthContext);
  const nowDate = new Date();
  const currentHour = nowDate.getHours();
  const [hotelList, setHotelList] = useState<HotelStoreType[]>([]);
  const [viweHotelList, setViweHotelList] = useState<HotelStoreType[]>([]);
  const [userId, setUserId] = useState<number[]>([]);
  const [selectedHotel, setSelectedHotel] = useState<any>(null);
  const [storeData, setStoreData] = useState<StoreStatusData[]>([]);
  const todayDate = moment().format('YYYY-MM-DD');

  const [todayDateTime, setTodayDateTime] = useState<string>('');
  const [modalOpne, setModalOpen] = useState<boolean>(false);
  const [modalData, setModalData] = useState<StoreStatusModalData | null>(null);
  const [pauseStatus, setPauseStatus] = useState<number>();
  const [searchDate, setSearchDate] = useState<Date | null>(nowDate);
  const [resetToday, setResetToday] = useState<boolean>(false);
  const [checkedBcodes, setCheckedBcodes] = useState<{ [key: string]: boolean }>({});

  const formattedDate = moment(searchDate).format('YYYY-MM-DD');
  const hourData = [];
  if (formattedDate === todayDate) {
    for (let i = 0; i <= currentHour; i++) {
      hourData.push(i);
    }
  } else {
    for (let i = 0; i <= 23; i++) {
      hourData.push(i);
    }
  }

  const [activeTab, setActiveTab] = useState(0);
  const tabContents = [{ title: '전체' }, { title: '호텔별' }, { title: '지역별' }];
  // 매장명 리스트
  const StoreNameList = ({ storeData, currentHour, formattedDate, todayDate }: any) => {
    return (
      <div className="left" style={{ marginTop: '50px' }}>
        {storeData &&
          storeData.length > 0 &&
          storeData.map((data: any, index: number) => {
            const storeName = data[0].store_name;
            const storeSector = data[0].parent_store_sector_name;
            const nowTimeStoreStatus = data.find(
              (store: StoreStatusData) => store?.hour === currentHour,
            );
            const nowStoreStatus =
              nowTimeStoreStatus &&
              nowTimeStoreStatus.store_open_yn === 1 &&
              (nowTimeStoreStatus.store_login_yn === 0 || nowTimeStoreStatus.pause === 1);

            return (
              <div className="listLine" key={index}>
                <button onClick={() => openModal(storeData[index])}>
                  <img
                    src={`${process.env.PUBLIC_URL}/svg/ic_more.svg`}
                    alt="물음표 아이콘"
                    width={14}
                  />
                </button>
                <h2
                  className={`storeName ${formattedDate === todayDate && nowStoreStatus && 'off'}`}>
                  {index + 1}.{storeName} {'(' + storeSector + ')'}
                </h2>
              </div>
            );
          })}
      </div>
    );
  };

  // 매장 상태 리스트
  const StoreStatusList = ({ storeData, hourData }: any) => {
    return (
      <div className="right">
        <div className="hourList">
          {hourData.map((item: number, index: number) => (
            <h3 key={index}>{item}시</h3>
          ))}
        </div>
        {storeData &&
          storeData.length > 0 &&
          storeData.map((data: any, index: number) => (
            <div className="operatingList" key={index}>
              {data.map((store: StoreStatusData, idx: number) => (
                <div className="operatingTimeWrap" key={idx}>
                  {store.store_availability_yn === 1 && <div className="activeStatus on">ON</div>}
                  {store.store_open_yn === 0 && store.store_availability_yn === 0 && (
                    <div className="activeStatus off">OFF</div>
                  )}
                  {store.store_open_yn === 1 &&
                    (store.store_login_yn === 0 || store.pause === 1) && (
                      <div className="activeStatus error">
                        <div className="errorIcon">
                          {store.store_login_yn === 0 && (
                            <img
                              src={`${process.env.PUBLIC_URL}/svg/ic_pos_logout.svg`}
                              alt="로그아웃"
                              width={16}
                            />
                          )}
                          {store.pause === 1 && (
                            <img
                              src={`${process.env.PUBLIC_URL}/svg/ic_pos_stop.svg`}
                              alt="일시정지"
                              width={9}
                              className="stop"
                            />
                          )}
                        </div>
                      </div>
                    )}
                </div>
              ))}
            </div>
          ))}
      </div>
    );
  };
  const tableHeader = [
    '호텔이름',
    '입점 매장수',
    '영업중 매장수',
    '영업종료 매장수',
    '비정상 매장수',
  ];
  const renderHotelTableItem = () => {
    return (
      <>
        {viweHotelList.map((data, dataIndex: number) => (
          <tr className="webTableWrap">
            <td>{data.hotel_name}</td>
            <td>{data.store_count}개</td>
            <td>{data.open_count}개</td>
            <td>{data.close_count}개</td>
            <td>{data.ab_normal_count}개</td>
          </tr>
        ))}
      </>
    );
  };

  const TotalTable = () => {
    return (
      <div>
        {todayDateTime && <h2 className="tableHeader">{todayDateTime} 시 기준</h2>}
        <CustomTable
          tableHeader={tableHeader}
          // subHeader={excelSubHeader}
          renderTableItem={renderHotelTableItem}
          type="border"
        />
      </div>
    );
  };

  const openModal = (data: StoreStatusData) => {
    setModalOpen(true);
    // setModalData(data);
    getStoreList(data);
  };
  const openPathLog = (startDate: Date | null, endDate: Date | null) => {
    getStoreStatus(startDate, endDate);
    setSearchDate(startDate);
  };
  const handleChange = (selectedOption: HotelListType | null) => {
    setSelectedHotel(selectedOption);
  };

  // 지역별 선택
  const handleSelectAll = (selectAll: boolean) => {
    const allUserIds = hotelList.map((hotel) => hotel.user_id);

    setCheckedBcodes((prev) => {
      const newChecked = allUserIds.reduce((acc: any, id) => {
        acc[id] = selectAll;
        return acc;
      }, {});
      return { ...prev, ...newChecked };
    });

    setUserId(selectAll ? allUserIds : []);
  };
  const handleCheckboxChange = (bcode: string) => {
    const userIdsWithBcode = hotelList
      .filter((hotel) => hotel.bcode === bcode)
      .map((hotel) => hotel.user_id);

    setCheckedBcodes((prev) => {
      const allSelected = userIdsWithBcode.every((id) => prev[id]);
      const newChecked = userIdsWithBcode.reduce((acc: any, id) => {
        acc[id] = !allSelected;
        return acc;
      }, {});
      return { ...prev, ...newChecked };
    });

    setUserId((prev) => {
      const userIdsSet = new Set(prev);
      userIdsWithBcode.forEach((id) => {
        if (userIdsSet.has(id)) {
          userIdsSet.delete(id);
        } else {
          userIdsSet.add(id);
        }
      });
      return Array.from(userIdsSet);
    });
  };

  // 전체 호텔 리스트
  const getHotelStoreTotal = async () => {
    try {
      const response = await DetectorController.getHotelStoreTotal();

      if (response && response.data) {
        console.log('getHotelStoreTotal', response.data.data);
        const formattedHotelList = response.data.data.map((item: any) => ({
          ...item,
          value: item.hotel_name,
          label: item.hotel_name,
        }));
        setHotelList(formattedHotelList);
        setTodayDateTime(moment().format('YYYY-MM-DD HH'));
      }
    } catch (err) {
      console.log('err-->', err);
    }
  };

  // 매장 상태값
  const getStoreStatus = async (startDate: Date | null, endDate: Date | null) => {
    setStoreData([]);

    try {
      const oData = {
        user_id: userId,
        start_date: moment(startDate).format('YYYY-MM-DD'),
        end_date: moment(endDate).format('YYYY-MM-DD'),
      };

      const response = await DetectorController.getStoreStatus(oData);

      if (response && response.data.ok) {
        const resData = response.data.data;
        const uniqueStores = [];
        for (const key in resData) {
          if (resData.hasOwnProperty(key)) {
            const storeEntries = resData[key];
            if (storeEntries.length > 0) {
              uniqueStores.push(storeEntries);
              setStoreData(uniqueStores);
            }
          }
        }
      } else {
        if (response.data.msg === 'VERIFY_ERROR') {
          logout();
        }
      }
    } catch (err) {
      console.log('err-->', err);
    }
  };
  // 매장 상세보기
  const getStoreList = async (data: any) => {
    const storeId = data[0].store_id;

    try {
      const response = await DetectorController.getStoreList(storeId);
      if (response && response.data) {
        setPauseStatus(response.data.data.pause);
        setModalData(response.data.data);
      }
    } catch (err) {
      console.log('err-->', err);
    }
  };

  useEffect(() => {
    getHotelStoreTotal();
  }, []);

  useEffect(() => {
    if (activeTab === 0 && hotelList.length > 0) {
      const userIds = hotelList.map((item: any) => item.user_id);
      setUserId(userIds);
    } else if (activeTab === 1 && hotelList.length > 0) {
      setSelectedHotel(hotelList[0]);
      const userIds = [hotelList[0].user_id];
      setUserId(userIds);
    } else if (activeTab === 2) {
      const firstBcode = hotelList[0]?.bcode;
      const userIds = hotelList
        .filter((item) => item.bcode === firstBcode)
        .map((item) => item.user_id);

      setUserId(userIds);
      setCheckedBcodes(userIds.reduce((acc: any, id: number) => ({ ...acc, [id]: true }), {}));
    }
  }, [activeTab, hotelList]);

  useEffect(() => {
    setViweHotelList(hotelList.filter((h) => userId.includes(h.user_id)));
  }, [userId, hotelList]);

  useEffect(() => {
    getStoreStatus(nowDate, nowDate);
    setResetToday(!resetToday);
  }, [userId]);
  useEffect(() => {
    if (selectedHotel?.user_id) {
      setUserId([selectedHotel.user_id]);
    }
  }, [selectedHotel]);

  return (
    <Style>
      <div className="wrap">
        <button className="backButton" onClick={() => navigate('/dashboard')}>
          <img src={`${process.env.PUBLIC_URL}/svg/ic_home.svg`} alt="뒤로가기버튼" />
        </button>
        <h1>매장 영업 현황</h1>
        <div className="tabWrap">
          {tabContents.map((tab, index) => (
            <button
              key={index}
              onClick={() => setActiveTab(index)}
              className={activeTab === index ? 'active' : ''}>
              {tab.title}
            </button>
          ))}
        </div>
        <TotalTable />
        {activeTab === 1 && (
          <div className="selectWrap">
            <Select options={hotelList} value={selectedHotel} onChange={handleChange} />
          </div>
        )}

        {activeTab === 2 && (
          <div className="areaListWrap">
            <button className="areaSortButton" onClick={() => handleSelectAll(true)}>
              전체 선택
            </button>
            <button className="areaSortButton" onClick={() => handleSelectAll(false)}>
              전체 해제
            </button>
            <div className="areaList">
              {Array.from(new Map(hotelList.map((item: any) => [item.bcode, item])).values()).map(
                (item: any) => (
                  <div key={item.user_id}>
                    <label>
                      <input
                        type="checkbox"
                        checked={Object.keys(checkedBcodes).some(
                          (key) => key === item.user_id.toString() && checkedBcodes[key],
                        )}
                        onChange={() => handleCheckboxChange(item.bcode)}
                      />
                      {item.name}
                    </label>
                  </div>
                ),
              )}
            </div>
          </div>
        )}
        <div className="header">
          <div className="dateWrap">
            <DateTab type="oneDay" openPathLog={openPathLog} resetToday={resetToday} />
          </div>
          <div className="statusGuide">
            <div className="row">
              <h2>포스 로그아웃</h2>
              <div className="activeStatus error">
                <div className="errorIcon">
                  <img
                    src={`${process.env.PUBLIC_URL}/svg/ic_pos_logout.svg`}
                    alt="로그아웃"
                    width={16}
                  />
                </div>
              </div>
            </div>
            <div className="row">
              <h2>포스 일시정지</h2>
              <div className="activeStatus error stop">
                <div className="errorIcon">
                  <img
                    src={`${process.env.PUBLIC_URL}/svg/ic_pos_stop.svg`}
                    alt="일시정지"
                    width={9}
                  />
                </div>
              </div>
            </div>
            <div className="row">
              <h2>영업중</h2>
              <div className="activeStatus on">ON</div>
            </div>
            <div className="row">
              <h2>영업시간 아님</h2>
              <div className="activeStatus off">ON</div>
            </div>
          </div>
        </div>
        <div className="contentWrap">
          <StoreNameList
            storeData={storeData}
            currentHour={currentHour}
            formattedDate={formattedDate}
            todayDate={todayDate}
          />
          <StoreStatusList storeData={storeData} hourData={hourData} />
        </div>
        <StoreStatusModal
          isVisible={modalOpne}
          setVisible={setModalOpen}
          modalData={modalData}
          pauseStatus={pauseStatus}
          setPauseStatus={setPauseStatus}
        />
      </div>
    </Style>
  );
};

export default StoreStatus;

const Style = styled.div`
  h1 {
    font-size: 24px;
    margin-bottom: 6px;
  }
  h2 {
    font-size: 14px;
    font-weight: 500;
  }
  h3 {
    font-size: 14px;
    font-weight: 500;
  }
  h4 {
    margin: 6px 0;
    font-size: 15px;
    font-weight: 400;
    color: #777777;
  }
  .holiday {
    color: #ff0000;
    font-weight: 500;
  }
  .errorText {
    margin-top: 4px;
    font-size: 14px;
    font-weight: 500;
    color: #ff8080;
  }

  /* wrap */
  .wrap {
    width: 100%;
    max-width: 100%;
    padding: 30px 2vw;
  }

  /* tabWrap */
  .tabWrap {
    width: 100%;
    margin: 10px 0;
    button {
      width: 10%;
      margin: -1px;
      padding: 10px;
      border: 1px solid #cecece;
    }
    .active {
      background: #000;
      color: #fff;
    }
    button:nth-child(1) {
      border-top-left-radius: 10px;
      border-bottom-left-radius: 10px;
    }
    button:nth-child(3) {
      border-top-right-radius: 10px;
      border-bottom-right-radius: 10px;
    }
  }
  .selectWrap {
    width: 30%;
  }
  /* areaListWrap */
  .areaListWrap {
    margin-top: 10px;
    padding: 16px 14px;
    border-radius: 5px;
    border: 1px solid #cecece;
    background: #fcfcfc;
    font-size: 14px;
  }
  .areaSortButton {
    padding: 4px 12px;
    margin-bottom: 10px;
    margin-right: 4px;
    border-radius: 50px;
    background: #fff;
    color: #333;
    border: 1px solid #4dd2ae;
  }
  .areaList {
    width: 100%;
    display: flex;
    align-items: center;
    gap: 14px;

    input {
      margin-right: 4px;
    }
    input[type='checkbox'] {
      accent-color: green;
    }
  }
  /* webTableWrap */
  table {
    width: 60%;
    margin-bottom: 20px;
  }
  .webTableWrap {
    text-align: center;
  }
  .tableHeader {
    font-size: 14px;
    margin-bottom: 4px;
    font-weight: 400;
  }

  /* header */
  .header {
    display: flex;
    justify-content: space-between;

    .dateWrap {
      margin-top: 12px;
    }
    .statusGuide {
      display: flex;
      align-items: end;
      gap: 8px;
    }
    .activeStatus {
      max-width: 40px;
      min-width: 40px;
      border-radius: 4px;
      margin-left: 4px;
    }
    .activeStatus.error {
      img {
        left: 38%;
        bottom: 2%;
        /* position: absolute; */
        height: 100%;
      }
    }
  }

  .contentWrap {
    width: 100%;
    margin-top: 14px;
    display: flex;
    align-items: flex-start;

    .left {
      width: 12%;
    }
    .right {
      width: 88%;
      max-height: 100%;
      overflow-y: auto;
    }
  }

  .hourList {
    height: 50px;
    display: flex;
    align-items: center;
    gap: 1px;

    h3 {
      min-width: 66px;
      max-width: 66px;
      gap: 4px;
      text-align: center;
    }
  }

  .listLine {
    display: flex;
    align-items: center;
    min-height: 20px;
    height: 100%;
    margin-bottom: 20px;

    button {
      background: none;
      border: none;
      outline: none;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-right: 2px;
    }
  }
  .storeName {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .storeName.off {
    color: red;
    font-weight: 700;
  }

  .operatingList {
    display: flex;
    align-items: center;
    min-height: 20px;
    height: 100%;
    margin-bottom: 20px;
  }
  .operatingTimeWrap {
    display: flex;
    align-items: center;
    justify-content: center;
    background: #ebebeb;
  }

  /* activeStatus */
  .activeStatus {
    min-width: 65px;
    max-width: 65px;
    display: ruby;
    margin: 0 1px;
  }
  .activeStatus.on {
    width: 100%;
    background: #4dd2ae;
    color: #4dd2ae;
    border-radius: 4px;
  }
  .activeStatus.off {
    background: #ebebeb;
    color: #ebebeb;
  }
  .activeStatus.error {
    position: relative;
    border-radius: 4px;
    background: #ff656d;

    .errorIcon {
      position: relative;
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 4px;
    }
  }

  @media (max-width: 1300px) {
    h2 {
      font-size: 10px;
    }
    .header {
      flex-direction: column;
      .selectWrap {
        width: 100%;
        margin-bottom: 18px;
      }
      .statusGuide {
        h2 {
          font-size: 10px;
        }
      }
      .activeStatus {
        max-width: 28px;
        min-width: 28px;
        gap: 4px;

        img {
          width: 12px;
        }
      }
      .activeStatus.stop {
        img {
          width: 8px;
        }
      }
    }
    table {
      width: 100%;
    }
    .contentWrap {
      margin-top: 0px;

      .left {
        width: 35%;
      }
      .right {
        flex: 1;
      }
    }
    .hourList h3 {
      min-width: 25px;
      max-width: 25px;
      font-size: 10px;
      gap: 2px;
    }
    .activeStatus {
      min-width: 24px;
      max-width: 24px;
      display: ruby;
      margin: 0 1px;
      font-size: 12px;
      height: 20px;

      img {
        width: 10px;
      }
      .errorIcon {
        gap: 2px;
      }
      .errorIcon img.stop {
        width: 8px;
      }
    }
    .tabWrap {
      button {
        width: 33%;
      }
    }
  }
`;
